<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m9.5 18h-1.5v-9h1.5zm3.25 0h-1.5v-9h1.5zm3.25 0h-1.5v-9h1.5zm1-12h-2v-3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3h-2c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2 0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1c1.1 0 2-.9 2-2v-11c0-1.1-.9-2-2-2zm-6.5-2.5h3v2.5h-3zm6.5 15.5h-10v-11h10z"
    />
  </svg>
</template>
